import { App } from 'vue';
import { GeocoderService } from './services/geocoder.service';

export default {
    install(app: App) {
        app.config.globalProperties.$geocoder = GeocoderService.getInstance();
    }
}